/**
 * Desktop header settings disclosure (region + language).
 * Coordinates sticky-header preventHide and Escape/outside close.
 */
if (!customElements.get('three-trees-header-settings')) {
  customElements.define(
    'three-trees-header-settings',
    class ThreeTreesHeaderSettings extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.header = document.querySelector('.header-wrapper');

        if (!this.details || !this.summary) return;

        this.onToggle = this.onToggle.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onPointerDownOutside = this.onPointerDownOutside.bind(this);

        this.details.addEventListener('toggle', this.onToggle);
        this.details.addEventListener('focusout', this.onFocusOut);
        this.addEventListener('keyup', this.onKeyUp);
        this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
        if (this.details.open) this.bindOutsidePointer();
      }

      disconnectedCallback() {
        if (!this.details) return;
        this.details.removeEventListener('toggle', this.onToggle);
        this.details.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('keyup', this.onKeyUp);
        this.unbindOutsidePointer();
      }

      onToggle() {
        const open = this.details.open;
        this.summary.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (this.header) this.header.preventHide = open;
        if (open) {
          this.bindOutsidePointer();
        } else {
          this.unbindOutsidePointer();
          this.closeLocalizationPanels();
        }
      }

      bindOutsidePointer() {
        if (this._outsideBound) return;
        document.addEventListener('pointerdown', this.onPointerDownOutside, true);
        this._outsideBound = true;
      }

      unbindOutsidePointer() {
        if (!this._outsideBound) return;
        document.removeEventListener('pointerdown', this.onPointerDownOutside, true);
        this._outsideBound = false;
      }

      onPointerDownOutside(event) {
        if (!this.details?.open) return;
        if (this.contains(event.target)) return;
        this.close();
      }

      onFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      }

      closeLocalizationPanels() {
        this.querySelectorAll('localization-form').forEach((form) => {
          if (typeof form.hidePanel === 'function') form.hidePanel();
        });
      }

      close() {
        if (!this.details?.open) return;
        this.details.removeAttribute('open');
        this.summary.setAttribute('aria-expanded', 'false');
        if (this.header) this.header.preventHide = false;
        this.unbindOutsidePointer();
        this.closeLocalizationPanels();
      }
    }
  );
}
